import React, { useState, useEffect } from 'react';
import { ChatBubbleLeftRightIcon, DocumentIcon } from '@heroicons/react/24/outline';
import { getSignedUrl } from '../../../services/s3Service';

const isHttp = u => /^https?:\/\//i.test(u || '');

const UnmatchedWhatsappPreview = ({ whatsapp, onAssign, onIgnore }) => {
  // La URL de S3 guardada es presigned y caduca (7 días); un WhatsApp sin asignar
  // puede estar pendiente semanas. Re-firmamos desde `s3_key` al seleccionarlo.
  const [media, setMedia] = useState(undefined);
  useEffect(() => {
    let active = true;
    setMedia(undefined);
    if (!whatsapp || whatsapp.message_type === 'text') return undefined;
    if (whatsapp.s3_key) {
      getSignedUrl(whatsapp.s3_key)
        .then(url => {
          if (active && isHttp(url)) setMedia(url);
        })
        .catch(() => {});
    } else if (isHttp(whatsapp.maytapi_url)) {
      setMedia(whatsapp.maytapi_url);
    }
    return () => {
      active = false;
    };
  }, [whatsapp]);

  if (!whatsapp) {
    return (
      <div className='h-full flex items-center justify-center text-slate-400'>
        <div className='text-center'>
          <ChatBubbleLeftRightIcon className='w-12 h-12 mx-auto mb-3 text-gray-300' />
          <p>Selecciona un WhatsApp para ver el detalle</p>
        </div>
      </div>
    );
  }

  const isPending = whatsapp.status === 'pending';

  return (
    <div className='h-full flex flex-col'>
      <div className='px-6 py-4 border-b border-slate-100'>
        <p className='text-sm text-slate-500'>De</p>
        <p className='text-lg font-semibold text-slate-800'>{whatsapp.debtor_phone}</p>
        <p className='text-xs text-slate-400 mt-1'>
          Recibido en la línea {whatsapp.owner_phone_id}
          {whatsapp.received_at
            ? ` · ${new Date(whatsapp.received_at).toLocaleString('es-ES')}`
            : ''}
        </p>
      </div>

      <div className='flex-1 overflow-y-auto px-6 py-4 space-y-4'>
        {whatsapp.message_text && (
          <p className='text-slate-700 whitespace-pre-wrap'>{whatsapp.message_text}</p>
        )}
        {whatsapp.caption && (
          <p className='text-slate-700 whitespace-pre-wrap'>{whatsapp.caption}</p>
        )}

        {whatsapp.message_type === 'image' && media && (
          <img src={media} alt={whatsapp.filename || 'imagen'} className='max-w-full rounded-lg border border-slate-200' />
        )}
        {whatsapp.message_type === 'ptt' && media && (
          // eslint-disable-next-line jsx-a11y/media-has-caption
          <audio controls src={media} className='w-full' />
        )}
        {whatsapp.message_type === 'document' && media && (
          <a
            href={media}
            target='_blank'
            rel='noreferrer'
            className='inline-flex items-center gap-2 px-3 py-2 border border-slate-200 rounded-lg text-sm text-slate-700 hover:bg-slate-50'
          >
            <DocumentIcon className='w-5 h-5 text-slate-400' />
            {whatsapp.filename || 'Documento'}
          </a>
        )}
      </div>

      {isPending && (
        <div className='px-6 py-4 border-t border-slate-100 flex justify-end gap-3'>
          <button
            type='button'
            onClick={() => onIgnore(whatsapp._id)}
            className='px-4 py-2 text-sm font-medium text-slate-700 bg-white border border-slate-300 rounded-lg hover:bg-slate-50'
          >
            Ignorar
          </button>
          <button
            type='button'
            onClick={() => onAssign(whatsapp)}
            className='px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700'
          >
            Asignar a expediente
          </button>
        </div>
      )}
    </div>
  );
};

export default UnmatchedWhatsappPreview;
